import type { ReactElement, ReactNode } from 'react';
import { Box, ButtonRow } from '@ksyos/design-system';
import { cloneElement } from 'react';
import FocusLock from 'react-focus-lock';
import { RemoveScroll } from 'react-remove-scroll';
import { CSSTransition } from 'react-transition-group';

interface IPermissionModalProps {
    actionButtons: ReactElement<{ key: number }>[];
    children: ReactNode;
    elementOnTop: ReactElement<{}> | null;
    visible: boolean;
}

export function PermissionModal(props: IPermissionModalProps) {
    return (
        <>
            <Box
                background="rgba(0,0,0,0.5)"
                height="100%"
                left="0"
                position="fixed"
                top="0"
                width="100%"
                zIndex="500"
            ></Box>
            <FocusLock>
                <RemoveScroll>
                    <Box
                        left="0"
                        position="fixed"
                        top="65px"
                        width="100%"
                        zIndex="500"
                    >
                        <CSSTransition
                            classNames="slide"
                            in={props.visible}
                            timeout={300}
                            transitionname="slide"
                            unmountOnExit
                        >
                            <Box
                                maxHeight="calc(100vh - 64px)"
                                overflowX="hidden"
                                overflowY="auto"
                                sx={{ backgroundColor: '#EDF2FF' }}
                            >
                                {props.elementOnTop}
                                <Box
                                    className="automation-permission-modal"
                                    display="flex"
                                    justifyContent="center"
                                >
                                    <Box
                                        maxWidth={'840px'}
                                        width="100%"
                                    >
                                        <Box
                                            pb={[20, 12]}
                                            px={4}
                                        >
                                            {props.children}
                                            <ButtonRow
                                                isStackedBelowSmall
                                                justify="right"
                                            >
                                                {props.actionButtons.map((button, i) =>
                                                    cloneElement(button, { key: i })
                                                )}
                                            </ButtonRow>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </CSSTransition>
                    </Box>
                </RemoveScroll>
            </FocusLock>
        </>
    );
}
